import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HeroVideo from './components/HeroVideo';
import IndianBrideJewelryCollection from './components/bridejewellery'
import './App.css'; // Tailwind configuration should be here
import TextComponent from './components/Text-1';
import ImageComponent from './components/ImageComponent';
import VideoComponent from './components/VideoComponent';
import TextComponentTwo from './components/Text-2';
import ImageLayout from './components/ImageLayout';
import SingleVideo from './components/SingleVideo';
import Footer from './components/Footer';
import TextComponentThree from './components/Text-3';
import WhatsNewPage from './components/WhatsNewPage';  
import HighJewelryComponent from './components/HighJewelryComponent';
import { Login}  from './components/login';
import { Signup } from './components/Register';
import {VerifyOtp} from './components/VerifyOtp';
import Catalogue from './components/Catalogue';
import './index.css'; // Tailwind configuration should be here
import EveryDay from './components/Everyday';
import { AuthProvider,useAuth } from './components/AuthContext';
import  History  from './components/History';
import Payment from './components/Payment';
import Confirmation from './components/Confirmation';
import {Success} from './components/Success'
import NotFound from './components/Notfound';
import Cancel from './components/Cancel';

function App() {
    return (
        <AuthProvider>
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={
                        <>
                            <Navbar />
                            <Hero />
                            <TextComponent />
                            <HeroVideo />
                            <ImageComponent />
                            <VideoComponent />
                            <TextComponentTwo />
                            <ImageLayout />
                            <SingleVideo />
                            <TextComponentThree />
                            <Footer />
                        </>
                    } />
                    <Route path="/whatsnew" element={
                        <>
                            <Navbar />
                            <WhatsNewPage />
                            <Footer />
                        </>
                    } />
                    <Route path="/HighJewelryComponent" element={
                        <>
                            <Navbar />
                            <HighJewelryComponent />
                            <Footer />
                        </>
                    } />
                    <Route path="/catalogue" element={
                        <>
                            <Navbar />
                            <Catalogue />
                            <Footer />
                        </>
                    } />
                    <Route path="/everyday" element={
                        <>
                            <Navbar />
                            <EveryDay />
                            <Footer />
                        </>
                    } />
                    <Route path="/login" element={<ProtectedRoute reverse={true} component={Login} />} />
                    <Route path="/register" element={<ProtectedRoute reverse={true} component={Signup} />} />
                    <Route path="/verifyotp" element={< VerifyOtp/>} />
                    <Route path="/history" element={<ProtectedRoute component={History} />} />
                    <Route path="/confirmation" element={<ProtectedRoute component={Confirmation} />} />
                    <Route path="/payment" element={<ProtectedRoute component={Payment} />} />
                    <Route path="/success" element={<ProtectedRoute component={Success}/>} />
                    <Route path="/cancel" element={<ProtectedRoute component={Cancel} />}/>
                    <Route path="*" element={<NotFound/>} />
                </Routes>
            </div>
        </Router>
        </AuthProvider>
    );
}
const ProtectedRoute = ({ component: Component, reverse = false }) => {
    const { isAuthenticated } = useAuth();
  
    if (reverse && isAuthenticated) {
      return <Navigate to="/" replace />;
    }
  
    if (!reverse && !isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
  
    return <Component />;
  };

export default App;
